import { render, staticRenderFns } from "./zoomBtn.vue?vue&type=template&id=1fc3a514"
import script from "./zoomBtn.vue?vue&type=script&lang=js"
export * from "./zoomBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports